/** Audience filter row is complete enough to match at runtime (and to allow asset picks). */
export const isAudienceFilterRowComplete = (row) => {
  if (!row?.property?.type) return false;
  if (row.operator === 'IS_EMPTY' || row.operator === 'NOT_EMPTY') {
    return true;
  }
  return (row.value?.length ?? 0) > 0;
};

export const setHasCompleteAudienceFilters = (set) =>
  (set?.filterRows ?? []).some(isAudienceFilterRowComplete);

export const setNeedsAssetSelection = (set, dynamic = false) => {
  if (!set || !setHasCompleteAudienceFilters(set)) return false;
  const ids = dynamic ? set.contentMappingIds : set.layoutMappingIds;
  return (ids?.length ?? 0) === 0;
};

export const personalizationSetsCanSave = (sets = [], dynamic = false) =>
  !sets.some((set) => setNeedsAssetSelection(set, dynamic));

export const personalizationSetHasName = (set) => (set?.name?.trim().length ?? 0) > 0;

export const personalizationSetsHaveValidNames = (sets = []) =>
  sets.every((set) => personalizationSetHasName(set));

export const personalizationSetIsSaveable = (set, dynamic = false) => {
  if (!personalizationSetHasName(set)) return false;
  if (!setHasCompleteAudienceFilters(set)) return false;
  return !setNeedsAssetSelection(set, dynamic);
};

export const personalizationSetsReadyToSave = (sets = [], dynamic = false) => {
  if (sets.length === 0) {
    return true;
  }
  return sets.every((set) => personalizationSetIsSaveable(set, dynamic));
};
